// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lesion-clinical-panel {
  display: flex;
  flex-direction: column;
  min-width: 260px;
  max-width: 360px;
  height: 100%;
  border-left: 1px solid #e1e5e9;
  background: #f8fafc;
  overflow: hidden;
}

.lesion-clinical-panel__header {
  flex-shrink: 0;
  padding: 10px 14px;
  border-bottom: 1px solid #e1e5e9;
  background: #ffffff;
}

.lesion-clinical-panel__header h4 {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}

.lesion-clinical-panel__subtitle {
  margin: 0;
  font-size: 12px;
  color: #64748b;
}

.lesion-clinical-panel__body {
  flex: 1 1;
  overflow: auto;
  padding: 10px 14px 14px;
}

.lesion-clinical-panel__section + .lesion-clinical-panel__section {
  margin-top: 14px;
}

.lesion-clinical-panel__section h5 {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #475569;
}

.lesion-clinical-panel__list {
  margin: 0;
}

.lesion-clinical-panel__row {
  display: grid;
  grid-template-columns: minmax(90px, 38%) 1fr;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #e2e8f0;
}

.lesion-clinical-panel__row:last-child {
  border-bottom: none;
}

.lesion-clinical-panel__row dt {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}

.lesion-clinical-panel__row dd {
  margin: 0;
  font-size: 13px;
  line-height: 1.35;
  color: #0f172a;
  word-break: break-word;
}

.lesion-clinical-panel__empty {
  padding: 16px 14px;
  margin: 0;
  font-size: 13px;
  color: #64748b;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/RegistrationDataTable/LesionClinicalPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,QAAQ;EACR,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".lesion-clinical-panel {\n  display: flex;\n  flex-direction: column;\n  min-width: 260px;\n  max-width: 360px;\n  height: 100%;\n  border-left: 1px solid #e1e5e9;\n  background: #f8fafc;\n  overflow: hidden;\n}\n\n.lesion-clinical-panel__header {\n  flex-shrink: 0;\n  padding: 10px 14px;\n  border-bottom: 1px solid #e1e5e9;\n  background: #ffffff;\n}\n\n.lesion-clinical-panel__header h4 {\n  margin: 0 0 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.lesion-clinical-panel__subtitle {\n  margin: 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.lesion-clinical-panel__body {\n  flex: 1;\n  overflow: auto;\n  padding: 10px 14px 14px;\n}\n\n.lesion-clinical-panel__section + .lesion-clinical-panel__section {\n  margin-top: 14px;\n}\n\n.lesion-clinical-panel__section h5 {\n  margin: 0 0 8px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #475569;\n}\n\n.lesion-clinical-panel__list {\n  margin: 0;\n}\n\n.lesion-clinical-panel__row {\n  display: grid;\n  grid-template-columns: minmax(90px, 38%) 1fr;\n  gap: 8px;\n  padding: 6px 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.lesion-clinical-panel__row:last-child {\n  border-bottom: none;\n}\n\n.lesion-clinical-panel__row dt {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.lesion-clinical-panel__row dd {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.35;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.lesion-clinical-panel__empty {\n  padding: 16px 14px;\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
